import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import CommandPalette from '../shared/CommandPalette';

const MainLayout = ({ children }) => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  // Routes that need full screen workspace (no padding, no main scroll)
  const isWorkspace = ['/files', '/efile', '/kanban'].some(path => 
    location.pathname.startsWith(path)
  );

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="absolute inset-0 flex h-[100dvh] w-full overflow-hidden font-sans antialiased bg-[radial-gradient(circle_at_top_left,_rgba(99,102,241,0.16),_transparent_30%),radial-gradient(circle_at_bottom_right,_rgba(14,165,233,0.14),_transparent_35%),linear-gradient(135deg,_#f8fbff_0%,_#edf3ff_26%,_#f7f8ff_58%,_#eef3ff_100%)]">
      <CommandPalette />
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="relative flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <TopBar onToggleSidebar={() => setSidebarOpen(v => !v)} />

        <main
          className={`flex h-full min-h-0 min-w-0 flex-1 flex-col ${
            isWorkspace
              ? 'overflow-hidden p-0'
              : 'overflow-y-auto overflow-x-hidden p-3 sm:p-4 lg:p-6 scrollbar-thin scrollbar-thumb-slate-300 scrollbar-track-transparent scroll-smooth'
          }`}
        >
          {isWorkspace ? (
            <div className="flex h-full min-w-0 w-full flex-col">
              {children || <Outlet />}
            </div>
          ) : (
            <div className="mx-auto w-full max-w-[1600px] min-w-0 pb-6">
              <div className="rounded-[30px] border border-white/60 bg-white/35 p-3 shadow-[0_28px_80px_rgba(15,23,42,0.08)] backdrop-blur-2xl sm:p-5 lg:p-6">
                {children || <Outlet />}
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
